import { ResourcePlanningFilterType } from "app/blocks/model/enums/resource-planning-filter/resource-planning-filter-type.enum";
import { IResourcePlanningFilter, ResourcePlanningFilter } from "app/blocks/model/resource-planning-filter/resource-planning-filter.model";

export interface IPlannerBoard extends IResourcePlanningFilter{}

export class PlannerBoard extends ResourcePlanningFilter {
    constructor(obj?){
        if (obj){
            obj.filterType = ResourcePlanningFilterType.PLANNER_BOARD;
        }
        super(obj);
    }
}